/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import * as API from "../../framework/API/api"
import { ENTITYNAME, LOGEVENT, MAM_STATUS, MODULE } from '../../framework/constant/constant';
import { toast } from 'react-toastify';
import { useTranslation } from '../../locale/useTranslation';
import { TimePickerWithFormat } from "../../framework/forms/helpercomponents/timepicker/TimePickerWithFormat";
import { EditPageHeader } from '../../components/EditPageHeader';
import { utility } from '../../framework/utility/utilityProvider';
import BossDialog from '../../components/BossDialog';
import { DropDownList } from '@progress/kendo-react-dropdowns';

const MediaMamAssetsEditForm = (props) => {

  const navigate = useNavigate();
  const lang = useTranslation();

  let blankDataItem = {
    SID: props.item.SID ?? 0,
    Title: '',
    AssetId: "",
    StartTime: "00:00:00:00",
    EndTime: "00:00:00:00",
    ActualDuration: "00:00:00:00",
    ProgramEditStatus: '',
    ReferenceId: '',
    TXReady: false,
    SubtitleAvailble: false,
    CensorshipReportAvailable: false,
    QcPass: false,
    Status: '',//{ _id: props.item.Status, Description: utility.getKeyByValue(MAM_STATUS, props.item.Status) },
    Archive: false,
    MediaEpisode_id: '',
  }

  const [dataItem, setDataItem] = useState(blankDataItem);
  const [ingestPrototype, setIngestPrototype] = useState([]);
  const [transcodePrototype, setTranscodePrototype] = useState([]);
  let mediaEpisodeRef = useRef();

  useEffect(() => {
    loadcombo();
    loadEditData();
    // if (props.item.SID > 0 || props.item.copy) {
    //   loadEditData();
    // }
  }, []);


  const loadcombo = async () => {
    console.log(props.item)
    let ingestprototypeRes = await API.getDataLookup(ENTITYNAME.INGEST_PROTOTYPE, { sort: { Description: 1 } });
    setIngestPrototype(ingestprototypeRes.data);
    let transcodeprototypeRes = await API.getDataLookup(ENTITYNAME.TranscodePrototypes, { sort: { Description: 1 } });
    setTranscodePrototype(transcodeprototypeRes.data);

    let mediaEpisodeRes = await API.getDataLookup(ENTITYNAME.MediaEpisode, { query: ["_id", "=", props.item.MediaEpisode_id ?? props?.item?.MediaEpisode?._id] });
    mediaEpisodeRef.current = mediaEpisodeRes.data.length > 0 ? mediaEpisodeRes.data[0] : {};
  }

  const loadEditData = async () => {
    setDataItem(prev => ({
      ...prev,
      ...props.item,
      SID: props.item.copy ? 0 : parseInt(props.item.SID),
      Title: props.item.copy ? `Copy of ${props.item.Title}` : props.item.Title,
      StartTime: utility.convertMilisecondsToStringWithFrames(props?.item?.StartTime) ?? "00:00:00:00",
      EndTime: utility.convertMilisecondsToStringWithFrames(props?.item?.EndTime) ?? "00:00:00:00",
      ActualDuration: utility.convertMilisecondsToStringWithFrames(props?.item?.ActualDuration) ?? "00:00:00:00",
      BitRate: props?.item?.TechnicalDetails?.BitRate,
      FileSize: props?.item?.TechnicalDetails?.FileSize,
      FileLocation: props?.item?.TechnicalDetails?.FileLocation,
      Checksum: props?.item?.TechnicalDetails?.Checksum,
      Status: {
        _id: props?.item?.Status,
        Description: utility.getKeyByValue(MAM_STATUS, props?.item?.Status)
      }
    }));
  };


  const onChange = async (e) => {
    if (e.target.name == "Archive") {
      setDataItem({ ...dataItem, Archive: !dataItem.Archive });
      console.log(!dataItem.Archive)
    }
    else if (e.target.name == "TXReady") {
      setDataItem({ ...dataItem, TXReady: !dataItem.TXReady });
      console.log(!dataItem.TXReady)
    }
    else if (e.target.name == "SubtitleAvailble") {
      setDataItem({ ...dataItem, SubtitleAvailble: !dataItem.SubtitleAvailble });
      console.log(!dataItem.SubtitleAvailble)
    }
    else if (e.target.name == "CensorshipReportAvailable") {
      setDataItem({ ...dataItem, CensorshipReportAvailable: !dataItem.CensorshipReportAvailable });
      console.log(!dataItem.CensorshipReportAvailable)
    }
    else if (e.target.name == "QcPass") {
      setDataItem({ ...dataItem, QcPass: !dataItem.QcPass });
      console.log(!dataItem.QcPass)
    }
    else {
      setDataItem({ ...dataItem, [e.target.name]: e.target.value });
    }
  };

  function validationCheck() {

    if (dataItem.Title == undefined || dataItem.Title == '') {
      toast.error(`${lang.please_enter_title_error_message}`, {
        position: toast.POSITION.TOP_RIGHT
      });
      return false;
    }
    if (dataItem.AssetId == undefined || dataItem.AssetId == '') {
      toast.error(`${lang.please_enter_assetid_error_message}`, {
        position: toast.POSITION.TOP_RIGHT
      });
      return false;
    }
    if (dataItem.StartTime == undefined || dataItem.StartTime == '' || utility.convertStringWithFramesToMilliseconds(dataItem.StartTime) == 0) {
      toast.error(lang.please_enter_valid_start_time_message, {
        position: toast.POSITION.TOP_RIGHT
      });
      return false;
    }

    if (dataItem.EndTime == undefined || dataItem.EndTime == '' || utility.convertStringWithFramesToMilliseconds(dataItem.EndTime) == 0) {
      toast.error(lang.please_enter_valid_end_time_message, {
        position: toast.POSITION.TOP_RIGHT
      });
      return false;
    }
    if (utility.convertStringWithFramesToMilliseconds(dataItem.EndTime) <= utility.convertStringWithFramesToMilliseconds(dataItem.StartTime)) {
      toast.error(
        <div>
          <strong>INVALID</strong>
          <div style={{ fontSize: '13px' }}>{lang.end_time_should_be_greater_than_start_time_error_message}</div>
        </div>,
        { position: toast.POSITION.TOP_RIGHT }
      );
      return false;
    }

    if (dataItem.ActualDuration == undefined || dataItem.ActualDuration == '' || utility.convertStringWithFramesToMilliseconds(dataItem.ActualDuration) == 0) {
      toast.error(lang.please_enter_valid_actual_duration_message, {
        position: toast.POSITION.TOP_RIGHT
      });
      return false;
    }
    if (dataItem.ReferenceId == undefined || dataItem.ReferenceId == '') {
      toast.error(`${lang.please_enter_reference_no_error_message}`, {
        position: toast.POSITION.TOP_RIGHT
      });
      return false;
    }
    if (dataItem.ProgramEditStatus == undefined || dataItem.ProgramEditStatus == '') {
      toast.error(`${lang.please_enter_programeditstatus_error_message}`, {
        position: toast.POSITION.TOP_RIGHT
      });
      return false;
    }
    if (!dataItem.Status._id || Object.keys(dataItem.Status._id).length == 0) {
      toast.error(lang.please_select_status_error_message, {
        position: toast.POSITION.TOP_RIGHT
      });
      return false
    }
    if (!dataItem.IngestPrototype || Object.keys(dataItem.IngestPrototype).length == 0) {
      toast.error(lang.please_select_ingest_prototype_error_message, {
        position: toast.POSITION.TOP_RIGHT
      });
      return false
    }
    if (!dataItem.TranscodePrototype || Object.keys(dataItem.TranscodePrototype).length == 0) {
      toast.error(lang.please_select_transcode_prototype_error_message, {
        position: toast.POSITION.TOP_RIGHT
      });
      return false
    }

    return true;
  }

  const onSaveData = async () => {

    if (!validationCheck()) return;

    const data = {
      _id: dataItem?._id,
      SID: dataItem?.SID,
      Title: dataItem?.Title,
      AssetId: dataItem?.AssetId,
      StartTime: utility.convertStringWithFramesToMilliseconds(dataItem?.StartTime) ?? "00:00:00:00",
      EndTime: utility.convertStringWithFramesToMilliseconds(dataItem?.EndTime) ?? "00:00:00:00",
      ActualDuration: utility.convertStringWithFramesToMilliseconds(dataItem?.ActualDuration) ?? "00:00:00:00",
      ProgramEditStatus: dataItem?.ProgramEditStatus,
      ReferenceId: dataItem?.ReferenceId,
      MediaEpisode_id: dataItem?.MediaEpisode_id ?? '',
      TXReady: dataItem?.TXReady ? true : false,
      SubtitleAvailble: dataItem?.SubtitleAvailble ? true : false,
      CensorshipReportAvailable: dataItem?.CensorshipReportAvailable ? true : false,
      QcPass: dataItem?.QcPass ? true : false,
      TechnicalDetails: {
        BitRate: dataItem?.BitRate,
        FileSize: dataItem?.FileSize,
        FileLocation: dataItem?.FileLocation,
        Checksum: dataItem?.Checksum
      },
      Status: dataItem.Status._id,
      IngestPrototype: dataItem.IngestPrototype && Object.keys(dataItem.IngestPrototype).length > 0 ? {
        _id: dataItem.IngestPrototype._id,
        Description: dataItem.IngestPrototype.Description
      } : {},
      TranscodePrototype: dataItem.TranscodePrototype && Object.keys(dataItem.TranscodePrototype).length > 0 ? {
        _id: dataItem.TranscodePrototype._id,
        Description: dataItem.TranscodePrototype.Description
      } : {},
      Archive: dataItem?.Archive ? true : false
    };

    props.item.copy && delete data._id

    const res = await API.saveData(ENTITYNAME.MediaMamAssets, data);
    if (res.success) {
      let logData = { event: data.SID == 0 ? LOGEVENT.CREATE_MAM_ASSETS : LOGEVENT.UPDATE_MAM_ASSETS, module: MODULE.MEDIA_EPISODE_MAMASSETS, data: res.data, message: res.message };
      API.SaveLogs(logData);
      props.cancelEdit();
      props.refresh();
      return;
    } else {
      toast.error(res.message, {
        position: toast.POSITION.TOP_RIGHT
      });
    }
  };

  const openMedia = (dataItem) => {
    if (mediaEpisodeRef.current.SID > 0) {
      props.cancelEdit();
      window.open(`/home/MediaEpisode/${mediaEpisodeRef.current?.MediaCategory?.Description}/${mediaEpisodeRef.current?.SID}`, { state: { copy: false } })
      //navigate(`/home/MediaEpisode/${mediaEpisodeRef.current?.MediaCategory?.Description}/${mediaEpisodeRef.current?.SID}`, { state: { copy: false } })
    } else {
      console.log('Select Media');
      toast.info(lang.select_media_info_message, {
        position: toast.POSITION.TOP_RIGHT
      });
    }
  }

  return (
    <BossDialog
      title={props.SID > 0 ? dataItem.Title : `${lang.create_mamasset_dialog_header}`}
      onClose={props.cancelEdit}
      width={"75vw"}
    >
      <div className="row">
        <div className="col-12">
          <div className="row align-items-center">
            <div className="col" >
              <EditPageHeader onSubmit={onSaveData} onCancel={props.cancelEdit} showTitle={false} OpenMediaButton={true} onShowMedia={openMedia} />
            </div>
            {props?.item?.SID > 0 && (
              <div className="col-auto d-flex align-items-center pull-right">
                <label className="mb-0 mr-2">{lang.mamID_label} :</label>
                <input
                  name="SID"
                  type="text"
                  className="form-control form-control-sm"
                  value={dataItem.SID}
                  disabled
                  style={{ width: "120px" }}
                />
              </div>
            )}
          </div>
          <div className='row'>
            <div className='col-12'>
              <div className="container-fluid mt-3" style={{ maxHeight: "65vh", overflowY: "auto", overflowX: "hidden" }}>
                <div className='row mx-0'>
                  <div className='col-12 px-2'>
                    <div className="row" >
                      <div className='col-6'>
                        <div className="form-group">
                          <label htmlFor="">{lang.title_label} *</label>
                          <input name="Title" type="text" className="form-control form-control-sm" value={dataItem.Title} onChange={(e) => onChange(e)} />
                        </div>
                      </div>
                      <div className='col-6'>
                        <div className="form-group">
                          <label htmlFor="">{lang.asset_id_label} *</label>
                          <input name="AssetId" type="text" className="form-control form-control-sm" value={dataItem.AssetId} onChange={(e) => onChange(e)} />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-3">
                        <div className="form-group">
                          <label htmlFor="">{lang.start_time_label} *</label>
                          <TimePickerWithFormat
                            className="form-control form-control-sm mt-1"
                            name="StartTime"
                            value={dataItem.StartTime}
                            onChange={onChange}
                          />
                        </div>
                      </div>
                      <div className="col-3">
                        <div className="form-group">
                          <label htmlFor="">{lang.end_time_label} *</label>
                          <TimePickerWithFormat
                            className="form-control form-control-sm mt-1"
                            name="EndTime"
                            value={dataItem.EndTime}
                            onChange={onChange}
                          />
                        </div>
                      </div>
                      <div className='col-3'>
                        <div className="form-group">
                          <label htmlFor="">{lang.actual_duration_label} *</label>
                          <TimePickerWithFormat
                            className="form-control form-control-sm mt-1"
                            name="ActualDuration"
                            value={dataItem.ActualDuration}
                            onChange={onChange}
                          />
                        </div>
                      </div>
                      <div className='col-3'>
                        <div className="form-group">
                          <label htmlFor="">{lang.reference_no_label} *</label>
                          <input name="ReferenceId" type="text" className="form-control form-control-sm" value={dataItem.ReferenceId} onChange={(e) => onChange(e)} />
                        </div>
                      </div>

                    </div>
                    <div className='row'>
                      <div className='col-3'>
                        <div className="form-group">
                          <label htmlFor="">{lang.program_edit_status_label} *</label>
                          <input name="ProgramEditStatus" type="text" className="form-control form-control-sm" value={dataItem.ProgramEditStatus} onChange={(e) => onChange(e)} />
                        </div>
                      </div>
                      <div className='col-3'>
                        <div className="form-group">
                          <label htmlFor="">{lang.status_label} *</label>
                          <DropDownList
                            style={{ backgroundColor: "white" }}
                            data={
                              Object.keys(MAM_STATUS).map((obj) => {
                                return {
                                  _id: MAM_STATUS[obj],
                                  Description: obj
                                }
                              })
                            }
                            name="Status"
                            textField="Description"
                            dataItemKey="_id"
                            value={dataItem.Status}
                            onChange={onChange}
                          />
                        </div>
                      </div>
                      <div className="col-3">
                        <div className="form-group">
                          <label>{lang.ingest_prototype_label} *</label>
                          <DropDownList
                            data={ingestPrototype}
                            name="IngestPrototype"
                            textField="Description"
                            dataItemKey="_id"
                            value={dataItem.IngestPrototype}
                            onChange={onChange}
                          />
                        </div>
                      </div>
                      <div className="col-3">
                        <div className="form-group">
                          <label>{lang.transcode_prototype_label} *</label>
                          <DropDownList
                            data={transcodePrototype}
                            name="TranscodePrototype"
                            textField="Description"
                            dataItemKey="_id"
                            value={dataItem.TranscodePrototype}
                            onChange={onChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row ml-1 group-box">
                      <span className="group-box-title"> {lang.technical_details_label} </span>
                      <div className="col-12">
                        <div className="row form-group">
                          <div className="col-3">
                            <label>{lang.bit_rate_label}</label>
                            <input
                              name="BitRate"
                              type="text"
                              className="form-control form-control-sm"
                              value={dataItem.BitRate}
                              onChange={onChange}
                            />
                          </div>
                          <div className="col-3">
                            <label>{lang.file_size_label}</label>
                            <input
                              name="FileSize"
                              type="text"
                              className="form-control form-control-sm"
                              value={dataItem.FileSize}
                              onChange={onChange}
                            />
                          </div>
                          <div className="col-3">
                            <label>{lang.file_location_label}</label>
                            <input
                              name="FileLocation"
                              type="text"
                              className="form-control form-control-sm"
                              value={dataItem.FileLocation}
                              onChange={onChange}
                            />
                          </div>
                          <div className="col-3">
                            <label>{lang.checksum_label}</label>
                            <input
                              name="Checksum"
                              type="text"
                              className="form-control form-control-sm"
                              value={dataItem.Checksum}
                              onChange={onChange}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mt-2 form-group">
                      <div className="col-3">
                        <input type="checkbox" name={"TXReady"} value={dataItem.TXReady} checked={dataItem.TXReady} onChange={onChange} /> {lang.tx_ready_label}
                      </div>
                      <div className="col">
                        <input type="checkbox" name={"SubtitleAvailble"} value={dataItem.SubtitleAvailble} checked={dataItem.SubtitleAvailble} onChange={onChange} /> {lang.subtitle_availble_label}
                      </div>
                      <div className="col-3">
                        <input type="checkbox" name={"CensorshipReportAvailable"} value={dataItem.CensorshipReportAvailable} checked={dataItem.CensorshipReportAvailable} onChange={onChange} /> {lang.censorship_report_available_label}
                      </div>
                      <div className="col">
                        <input type="checkbox" name={"QcPass"} value={dataItem.QcPass} checked={dataItem.QcPass} onChange={onChange} /> {lang.qcpass_label}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-6">
                        <input style={{ marginTop: "05px" }} type="checkbox" name={"Archive"} checked={dataItem.Archive} onChange={onChange} /> {lang.archive}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </BossDialog >
  )
}

export default MediaMamAssetsEditForm